import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const features = [{
  title: 'Logística de Salida',
  desc: 'Cómo organizar tu mudanza y documentos en solo 14 días.'
}, {
  title: 'Protección de Capital',
  desc: 'El protocolo para mover tus ahorros de USA a un nuevo banco sin bloqueos ni riesgos.'
}, {
  title: 'Mapa de Residencia',
  desc: 'Los países que te otorgan papeles legalmente solo por demostrar ahorros o ingresos estables.'
}, {
  title: 'Arbitraje Financiero',
  desc: 'Cómo vivir con estándares de lujo en ciudades seguras gastando menos de $1,500 al mes.'
}, {
  title: 'Dignidad Retornada',
  desc: 'Pasos para dejar de ser un número más y convertirte en dueño de tu propio destino.'
}];
export function ProductContents() {
  return <section className="py-12 md:py-20 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-289">
      <div className="max-w-[720px] mx-auto" data-id="element-290">
        <div className="text-center mb-10 md:mb-14" data-id="element-291">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block mb-6 relative" data-id="element-292">
            <img src="https://cdn.magicpatterns.com/uploads/tfS3vCDpgVvpPUPiKrgPFg/cover.png" alt="Plan B Migratorio" className="w-32 md:w-48 rounded-lg shadow-[0_0_40px_rgba(212,136,58,0.3)] border border-[var(--accent)]/30" data-id="element-293" />
          </motion.div>

          <h2 className="text-2xl md:text-4xl font-serif text-[var(--text-heading)] mb-4" data-id="element-294">
            Todo lo que aprenderás en la Guía <br className="hidden md:block" data-id="element-295" />
            <span className="text-[var(--accent)] italic" data-id="element-296">
              "Plan B Migratorio":
            </span>
          </h2>
        </div>

        <div className="bg-[var(--bg-card)] rounded-2xl border border-[var(--accent)]/20 p-6 md:p-10 shadow-xl mb-8" data-id="element-297">
          <div className="space-y-6" data-id="element-298">
            {features.map((feature, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4" data-id="element-299">
                <CheckCircle2 className="w-6 h-6 text-[var(--trust-green)] flex-shrink-0 mt-0.5" data-id="element-300" />
                <div data-id="element-301">
                  <h3 className="text-lg md:text-xl font-bold text-[var(--text-heading)] mb-1" data-id="element-302">
                    {feature.title}
                  </h3>
                  <p className="text-base text-[var(--text-muted)] leading-relaxed" data-id="element-303">
                    {feature.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-304">
          <div className="inline-block bg-[var(--accent)]/10 border border-[var(--accent)]/30 rounded-full px-6 py-3" data-id="element-305">
            <p className="text-lg md:text-xl font-bold text-[var(--text-heading)]" data-id="element-306">
              ACCESO TOTAL HOY POR SOLO:{' '}
              <span className="text-[var(--accent)]" data-id="element-307">$6.99</span>
            </p>
            <p className="text-sm text-[var(--text-muted)] mt-1" data-id="element-308">
              (Pago único - Sin suscripciones)
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}